
import {Vue, Component, Prop} from "vue-property-decorator";
@Component({})
export default class Stepper extends  Vue {
    @Prop({default: []})
    public steps: object[];

    @Prop({default: {}})
    public relay: object;

}
